import {Modal} from 'bootstrap';
import {Component, ElementRef, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {PermissionsService} from '../../../../Services/permissions.service';

@Component({
  selector: 'app-modal-uninvoiced-quotes',
  templateUrl: './modal-uninvoiced-quotes.component.html',
  styleUrls: ['./modal-uninvoiced-quotes.component.css'],
  standalone: false
})
export class ModalUninvoicedQuotesComponent implements OnInit, OnDestroy {
  @ViewChild('closeButton') closeButton: ElementRef;
  @Input() vm: any;
  constructor(
    public router: Router,
    private permissionsService: PermissionsService
  ) { }

  get hasReceivableInvoicePermission(): boolean {
    return this.permissionsService.Get('Admin') ||
      this.permissionsService.Get('EditReceivableInvoices');
  }

  ngOnInit() {
  }
  ngOnDestroy() {
    const modalEl = this.closeButton?.nativeElement?.closest('.modal');
    if (modalEl) {
      const modal = Modal.getInstance(modalEl);
      if (modal) {
        modal.hide();
      }
    }
  }

  generateQuoteInvoice(id) {
    // this.router.navigate(['transactions/invoice/form?',  {invoiceId: 'newAR', quoteId: id}]);
    this.router.navigateByUrl('/transactions/invoice/ar/form?invoiceId=newAR&quoteId=' + id);
    //  this.router.navigateByUrl('/inventory/count/form?countId=' + item.id);
    //   this.router.navigate(['admin/account-subtotal-form', { id: aID }]);
    // $('#uninvoicedQuotes').modal('hide');
    // $state.go('app.admin.transactions.invoice.form', { invoiceId: 'newAR', quoteId: id });

  }

}

